import { render, staticRenderFns } from "./TenantFeatures.vue?vue&type=template&id=075b050b&"
import script from "./TenantFeatures.vue?vue&type=script&lang=ts&"
export * from "./TenantFeatures.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports